import React from "react";
import styles from "./Product.module.css";
import { useNavigate } from "react-router-dom";
import ProductFetcher from "../../../utils/productFetcher";

function Product({ product }) {
  const navigate = useNavigate();

  const handleProductClick = () => {
    navigate(`/Product/${product.name}`);
  };

  return (
    <>
      <li
        className={`${styles.productCont}`}
        key={product.id}
        onClick={(e) => handleProductClick(product)}>
        <div className={`${styles.product}`}>
          <figure className={`${styles.productImage}`}>
            <img src={product.img} alt={product.name} />
          </figure>
          <div className={styles.productDetails}>
            <h4>{product.name}</h4>
            <div className={`${styles.productDesc}`}>
              <p>{product.portfolio}</p>
            </div>
          </div>
        </div>
      </li>
    </>
  );
}

export default Product;
